import { createSlice } from "@reduxjs/toolkit";
import { getState } from "@bd-stores/store";
import CONFIG from "@bd-core/config";

const initialState = {
    roomsAnswer: {},
};

const gameDataSlice = createSlice({
    name: "gameData",
    initialState,
    reducers: {
        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameData['roomsAnswer']>} action
         */
        setRoomsAnswer: (state, action) => ({
            ...state,
            roomsAnswer: action.payload,
        }),
    },
});

export const getRoomAnswerById = (id) => {
    const rooms = getState().gameData.roomsAnswer;
    const room = rooms?.[id] || {};
    return room;
};

export const getRoomByType = (pageType) => {
    const room = CONFIG.game.rooms.find((r) => r.type == pageType);
    return room?.id || 0;
}

export const getRoomById = (id) => {
    const room = CONFIG.game.rooms.find((r) => r.id == id);
    return room || {};
}

export const { setRoomsAnswer } = gameDataSlice.actions;
export const gameData = gameDataSlice.reducer;
